import { api, ApiResponse } from './api';

export interface PrescriptionCancellationRequest {
  id: string;
  prescription_id: string;
  status: 'pending' | 'approved' | 'rejected';
  reason: string;
  rejection_reason?: string;
  requested_by: string;
  requested_at: string;
  reviewed_by?: string;
  reviewed_at?: string;
  metadata?: Record<string, any>;
  requester?: {
    id: string;
    email: string;
    first_name?: string;
    last_name?: string;
  };
  reviewer?: {
    id: string;
    email: string;
    first_name?: string;
    last_name?: string;
  };
}

export interface RequestCancellationPayload {
  reason: string;
}

export const prescriptionCancellationService = {
  /**
   * Request cancellation of a prescription
   */
  requestCancellation: async (
    prescriptionId: string,
    payload: RequestCancellationPayload
  ): Promise<ApiResponse<PrescriptionCancellationRequest>> => {
    const response = await api.post<ApiResponse<PrescriptionCancellationRequest>>(
      `clinic/prescriptions/${prescriptionId}/cancel-request`,
      payload
    );
    return response.data;
  },

  /**
   * Get cancellation request for a prescription
   */
  getCancellationRequest: async (
    prescriptionId: string
  ): Promise<ApiResponse<PrescriptionCancellationRequest>> => {
    const response = await api.get<ApiResponse<PrescriptionCancellationRequest>>(
      `clinic/prescriptions/${prescriptionId}/cancel-request`
    );
    return response.data;
  }
};

